import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../../serviceRequestBase';

export class CoreConfigGetRequestBody extends NaniumObject<CoreConfigGetRequestBody> {
}

export class CoreConfigGetResponse extends NaniumObject<CoreConfigGetResponse> {
	@Type(Number) portalLaunchTime: number;
	@Type(Number) applicationDeadline?: number;
	@Type(String) paypalClientId: string;
	@Type(String) paymentCurrency: string;
	@Type(Number) paymentPrice: number;
}

@RequestType({
	responseType: CoreConfigGetResponse,
	genericTypes: { TRequestBody: CoreConfigGetRequestBody },
	scope: 'public',
	skipInterceptors: ['MainRequestInterceptor'],
})
export class CoreConfigGetRequest extends ServiceRequestBase<CoreConfigGetRequestBody, CoreConfigGetResponse> {
	static serviceName: string = 'EduApplication:core/config/get';
}
